import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';
import SLAHealthPercentageCellRenderer from '@/pages/agGridUtils/SLAHealthPercentageCellRenderer.vue';

/**
 * Transform Grid Data for - Assignment Health by Workload
 *
 * @param metrics
 */
export const tfGdAssignmentHealthByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {
    const gridMap = new Map<number, object>();
    for (const assignmentMetric of metrics) {
        // SLA Health is calculated as Open / (Open + At Risk + Breached)* 100.
        const slaHealthBoP = assignmentMetric.slaHealthBoP ?? 0;
        const slaHealthEoP = assignmentMetric.slaHealthEoP ?? 0;

        // Next to the SLA Health value is a trend percentage indicating change. It is calculated as (SLA Health [@ Last Interval] - SLA Health [@ First Interval]) / SLA Health [@ First Interval] * 100 .
        const slaHealthPercentChanges = slaHealthBoP ? roundToOneDecimal(((slaHealthEoP - slaHealthBoP) / slaHealthBoP) * 100) : 0;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: assignmentMetric.name,
            openWithinSLAEoP: assignmentMetric.openWithinSLAEoP,
            openAtRiskEoP: assignmentMetric.openAtRiskEoP,
            openBreachedEoP: assignmentMetric.openBreachedEoP,
            openCountEoP: assignmentMetric.openCountEoP,
            slaHealthEoP: assignmentMetric.slaHealthEoP,

            slaHealthPercentChanges
        };
        gridMap.set(assignmentMetric.workloadId, row);
    }
    return Array.from(gridMap.values());
};

/**
 * Colum Definition for Assignment Health by Workload
 */
export const getAssignmentHealthByWorkloadColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workload', minWidth: 220, filter: true
        },
        {
            field: 'openWithinSLAEoP', headerName: 'Open in SLA', filter: true
        },
        {
            field: 'openAtRiskEoP', headerName: 'Open At Risk', flex: 2, filter: true
        },
        {
            field: 'openBreachedEoP', headerName: 'Open Breached', flex: 2, filter: true
        },
        {
            field: 'slaHealthEoP', headerName: 'SLA Health %', cellRenderer: SLAHealthPercentageCellRenderer, flex: 2, filter: true
        }
    ];
};